import { render } from "./NewStaff.vue?vue&type=template&id=d4e43b0c&scoped=true"
import script from "./NewStaff.vue?vue&type=script&lang=js"
export * from "./NewStaff.vue?vue&type=script&lang=js"

import "./NewStaff.vue?vue&type=style&index=0&id=d4e43b0c&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e43b0c"]])

export default __exports__